<template>
	<div class="upload__loader" v-if="isUploadingFile">
		<SpinnerIcon :color="'#597393'" />
	</div>
	<section v-else class="upload">
		<div class="upload-heading">
			<div class="upload-heading__icon" @click="goBack">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="upload-heading__title">Upload de carteira</h1>
		</div>
		<h2 class="upload-heading__subtitle">Atenção aos pontos abaixo:</h2>
		<ul class="upload__info">
			<li>Arquivos permitidos: csv (podendo ser zipado)</li>
			<li>Colunas sem caracteres especiais</li>
			<li>Formato aceito para as datas: yyyy-MM-dd</li>
			<li>Casas decimais separadas por ponto (.): ###.##</li>
			<li>Valores permitidos para o campo 'tp_operacao': Capitalização e Descapitalização</li>
		</ul>
		<form class="upload-form" @submit.prevent="uploadData">
			<div class="upload-form-row">
				<InputGroup
					title="Arquivo"
					id="upload__input"
					ref="file"
					placeholder="Selecione o arquivo"
					customClass="full"
					:isFile="true"
					:isTeaser="true"
					@clearTeaser="clearTeaser"
					v-model="formData.file"
				/>
				<MultiselectGroup
					label="Tipo de Carga:"
					type="loadType"
					placeholder="Tipo de Carga"
					customClass="upload-form-row__input"
					:isWeb="isWeb"
					:options="loadOptions"
					:alert="false"
					@changeMultiselectInput="handleSelect"
				/>
			</div>
			<ButtonPrimary label="Upload" size="md" type="submit" />
		</form>
	</section>
</template>
<script>
import { mapActions } from 'vuex';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';
import ButtonPrimary from '../../../components/shared/Button/ButtonPrimary/ButtonPrimary.vue';
import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import { UPLOAD_OFFER_WALLET } from '../../../store/modules/offerManagement/actions';

export default {
	components: {
		MultiselectGroup,
		ButtonPrimary,
		SidebarArrow,
		SpinnerIcon,
		InputGroup,
	},
	props: {
		originatorName: {
			type: String,
			required: true,
		},
    originatorId: {
			type: String,
			required: true,
		},
		offerId: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		isUploadingFile: false,
		formData: {
			file: null,
			loadType: null,
		},
		loadOptions: [
			{
				id: true,
				name: 'Full',
			},
			{
				id: false,
				name: 'Delta',
			},
		],
	}),
	methods: {
    ...mapActions('offerManagement', {
			uploadOfferWallet: UPLOAD_OFFER_WALLET
		}),
		goBack() {
			this.$router.push({ name: 'Ofertas' });
		},
		clearTeaser() {
			this.formData.file = null;
		},
		async uploadData() {
      if (!this.isFormValid()) {
          return;
      }

      try {
          this.isUploadingFile = true;
          const formData = new FormData();

          const walletFile = this.$refs.file.getFile();
          if (walletFile != null) {
              formData.append('file', walletFile);
          }

          formData.append('data', JSON.stringify({
              offerId: this.offerId,
              originatorId: this.originatorId,
              originatorName: this.originatorName,
              isFullLoad: this.formData.loadType
          }));

          await this.uploadOfferWallet({
              vm: this,
              body: formData
          });
      } catch (error) {
          console.error(error);
      } finally {
          this.isUploadingFile = false;
      }
    },
		handleSelect(param) {
			const value = param.value === null ? null : param.value.id;
			this.formData.loadType = value;
		},

		isFormValid() {
			if (this.formData.file === null) {
				this.$toastr.e('É necessário selecionar um arquivo');
				return false;
			} else if (this.formData.loadType === null) {
				this.$toastr.e('É necessário selecionar o tipo de carga');
				return false;
			}
			return true;
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
	},
};
</script>
<style lang="scss" scoped>
@import './FileUpload.scss';
</style>
